import React from 'react'
import { Text } from 'components/base'
import EntryPlaceholder from './EntryPlaceholder'

export default function AnalyticsTable({
  title,
  secondaryTitle,
  entries = [],
  loading = false,
  renderRow = () => null,
  renderValue = () => null,
  renderPlaceholderIcon = () => null,
}) {
  if (loading) {
    return (
      <div>
        <header className="flexbox flexbox-space-between margin-bottom-normal">
          <Text.Detail>{title}</Text.Detail>
          <Text.Detail>{secondaryTitle}</Text.Detail>
        </header>
        <main>
          {Array(10)
            .fill(null)
            .map((_, index) => (
              <EntryPlaceholder
                key={index}
                hasLoadingPulseAnimation={true}
                renderPlaceholderIcon={renderPlaceholderIcon}
              />
            ))}
        </main>
      </div>
    )
  }

  const hasEntries = Boolean(entries.length)

  if (!hasEntries) {
    return (
      <div>
        <header className="flexbox flexbox-space-between margin-bottom-normal">
          <Text.Detail>{title}</Text.Detail>
          <Text.Detail>{secondaryTitle}</Text.Detail>
        </header>
        <main>
          <Text.SmallDetail>No data for this section</Text.SmallDetail>
        </main>
      </div>
    )
  }

  return (
    <div>
      <header className="flexbox flexbox-space-between">
        <Text.Detail>{title}</Text.Detail>
        <Text.Detail>{secondaryTitle}</Text.Detail>
      </header>
      <main>
        {entries.map((entry, index) => {
          return (
            <div
              key={index}
              style={{
                lineHeight: '24px',
              }}
              className="flexbox flexbox-space-between flexbox-align-center margin-top-normal"
            >
              <div style={{ maxWidth: '90%' }}>{renderRow(entry)}</div>
              <div className="font-weight-medium">{renderValue(entry)}</div>
            </div>
          )
        })}
      </main>
    </div>
  )
}
